import { theme } from '@weave/theme';

export const getStateBackgroundColor = (state: string | undefined): string => {
  switch (state) {
    case 'MERGE_PENDING':
    case 'ROLLBACK_PENDING':
      return theme.colors.primary10;
    case 'MERGE_PROCESSING':
    case 'ROLLBACK_PROCESSING':
      return theme.colors.warning5;
    case 'MERGE_COMPLETED':
    case 'ROLLBACK_COMPLETED':
      return theme.colors.success10;
    case 'MERGE_FAILED':
    case 'ROLLBACK_FAILED':
      return theme.colors.critical20;
    case 'UNSPECIFIED':
    default:
      return theme.colors.neutral10;
  }
};
